import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPresent = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.13636 2.27273C4.8832 2.27273 4.64041 2.3733 4.4614 2.55231C4.28239 2.73132 4.18182 2.97411 4.18182 3.22727C4.18182 3.48043 4.28239 3.72323 4.4614 3.90224C4.64041 4.08125 4.8832 4.18182 5.13636 4.18182H7.14347C7.06578 3.97857 6.96744 3.75508 6.84582 3.53395C6.44557 2.80622 5.89612 2.27273 5.13636 2.27273ZM7.36364 5.45455V7.36364H2.27273V5.45455H7.36364ZM3.124 4.18182C2.98382 3.88627 2.90909 3.56063 2.90909 3.22727C2.90909 2.63656 3.14375 2.07005 3.56144 1.65235C3.97914 1.23466 4.54565 1 5.13636 1C6.60388 1 7.48625 2.05742 7.961 2.9206C7.97424 2.94466 7.98723 2.96871 8 2.99272C8.01277 2.96871 8.02576 2.94466 8.039 2.9206C8.51375 2.05742 9.39612 1 10.8636 1C11.4543 1 12.0209 1.23466 12.4386 1.65235C12.8562 2.07005 13.0909 2.63656 13.0909 3.22727C13.0909 3.56063 13.0162 3.88627 12.876 4.18182H14.3636C14.7151 4.18182 15 4.46673 15 4.81818V8C15 8.35145 14.7151 8.63636 14.3636 8.63636H13.7273V14.3636C13.7273 14.7151 13.4424 15 13.0909 15H2.90909C2.55764 15 2.27273 14.7151 2.27273 14.3636V8.63636H1.63636C1.28491 8.63636 1 8.35145 1 8V4.81818C1 4.46673 1.28491 4.18182 1.63636 4.18182H3.124ZM3.54545 8.63636V13.7273H7.36364V8.63636H3.54545ZM8.63636 8.63636V13.7273H12.4545V8.63636H8.63636ZM13.7273 7.36364H8.63636V5.45455H13.7273V7.36364ZM10.8636 4.18182C11.1168 4.18182 11.3596 4.08125 11.5386 3.90224C11.7176 3.72323 11.8182 3.48043 11.8182 3.22727C11.8182 2.97411 11.7176 2.73132 11.5386 2.55231C11.3596 2.3733 11.1168 2.27273 10.8636 2.27273C10.1039 2.27273 9.55443 2.80622 9.15418 3.53395C9.03256 3.75508 8.93422 3.97857 8.85653 4.18182H10.8636Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPresent)
const IconSvgPresent = createIcon(ForwardRef, 'SvgPresent')
export default IconSvgPresent
